import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import rightImg from "../../Assets/Images/FAQ_SideImg.png";

const faqItems = [
  {
    question: "In elementum est a ante sodales iaculis.",
    answer:
      "Morbi porttitor ligula in nunc varius sagittis. Proin dui nisi, laoreet ut tempor ac, cursus vitae eros. Cras quis ultricies elit. Proin ac lectus arcu. Maecenas aliquet vel tellus at accumsan. Donec a eros non massa vulputate ornare. Vivamus ornare commodo ante, at commodo felis congue vitae.",
  },
  {
    question: "What services do you offer?",
    answer:
      "We provide a wide range of automotive solutions including vehicle servicing, spare parts, accessories, and maintenance support.",
  },
  {
    question: "Can I book a service appointment online?",
    answer:
      "Absolutely! You can book your service slot online through our website by selecting your preferred date and time..",
  },
  {
    question: "Do you provide warranty on parts and services?",
    answer:
      "Yes, all our products and services come with a warranty. The duration of the warranty depends on the specific product or service.",
  },
  {
    question: "Which types of vehicles do you service?",
    answer:
      "We service all types of vehicles including cars, motorcycles, commercial vehicles, and specialized automotive equipment.",
  },
  {
    question: "How can I track my service status?",
    answer:
      "Once your vehicle is checked in, you can track its service progress through our website or by contacting our customer support team.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major payment methods including UPI, credit/debit cards, net banking, and cash at the service center.",
  },
  {
    question: "Do you offer doorstep vehicle pickup and drop service?",
    answer:
      "Yes, we provide convenient pickup and drop services to save your time and effort.",
  },
  {
    question: "Do you provide emergency roadside assistance?",
    answer:
      "Yes, our 24/7 roadside assistance is available for breakdowns, towing, flat tires, or battery issues.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major payment methods including UPI, credit/debit cards, net banking, and cash at the service center.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(true);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <>
      <div>
        <div className="bg-white flex justify-between px-4 lg:px-10 py-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Left: FAQ Content */}
            <div>
              <p className="text-[#E8471B] text-lg font-montserrat font-medium leading-[24px] tracking-[0.5px] capitalize">
                FAQs
              </p>
              <h2 className="text-[#030B25] mt-2 mb-4 font-orbitron font-semibold text-3xl sm:text-4xl leading-[130%] tracking-[1px] capitalize">
                Frequently Asked Questions
              </h2>

              <div className="space-y-4">
                {faqItems.map((item, index) => {
                  const isOpen = openIndex === index;
                  return (
                    <div
                      key={index}
                      className={`rounded-xl overflow-hidden border transition-all duration-300 ${
                        isOpen
                          ? "border-[#E8471B] bg-white"
                          : "border border-[#FDD9CC] bg-[#FFF6F2]"
                      }`}
                    >
                      <button
                        onClick={() => toggle(index)}
                        className={`w-full flex justify-between items-center text-left p-4 font-medium focus:outline-none ${
                          isOpen ? "text-[#E8471B]" : "text-[#030B25]"
                        }`}
                      >
                        <span className="text-sm sm:text-base md:text-lg">
                          {item.question}
                        </span>
                        <span
                          className={`flex items-center justify-center w-6 h-6 rounded-full ${
                            isOpen
                              ? "bg-[#E8471B] text-white"
                              : "bg-[#E5E5E5] text-[#030B25]"
                          }`}
                        >
                          {isOpen ? (
                            <FaMinus size={12} />
                          ) : (
                            <FaPlus size={12} />
                          )}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="px-4 pb-4 text-gray-600 text-sm leading-relaxed">
                          {item.answer}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right: Support Us */}
            <div>
              <img src={rightImg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
